// extracted by mini-css-extract-plugin
module.exports = {"site":"RateOfWasteByItemChart_site__wlrcQ"};